import * as React from "react";

import {CategoryCacheProvider} from "../../organisms/category-cache/category-cache";
import {TagCacheProvider} from "../../organisms/tag-cache/tag-cache";
import {UserListCacheProvider} from "../../organisms/user-list-cache/user-list-cache";

type PageScopeCacheProviderProps = React.PropsWithChildren<{}>;

export const PageScopeCacheProvider: React.FC<PageScopeCacheProviderProps> = ({children}) => (
    <CategoryCacheProvider>
        <TagCacheProvider>
            <UserListCacheProvider>{children}</UserListCacheProvider>
        </TagCacheProvider>
    </CategoryCacheProvider>
);
